import { getProfilesByResource } from './GetProfilesByResource'

export const lmsProfilesService = {
  getProfilesByResource,
}
